import React from 'react';
import cx from 'classnames';
import { Button, LucideIcon as Icon, Text } from '../../../../../ui-kit';
import { Trash2, Download } from 'lucide-react';
import AssetPreview from '../../../../AssetPreview';
import { DownloadAssetMenu } from '../../../../DownloadAssetMenu';

const getAssetTitle = (title, filename) => {
  if (!title || !filename) {
    return {};
  }

  const filenameSplit = filename.split('.');
  const fileExtension = filenameSplit[filenameSplit.length - 1];
  const titleSplit = title.split(`.${fileExtension}`);

  return { fileExtension, title: titleSplit[0] };
};

const CommentAsset = ({
  asset,
  deleteAsset,
  isV2Design




}) => {
  const { fileExtension, title } = getAssetTitle(asset.title, asset.filename);

  const renderDeleteAssetButton = () => {
    if (!deleteAsset) return null;

    if (isV2Design) {
      return (
        <Icon
          size={16}
          icon={Trash2}
          color="regent"
          hoverColor="redApple"
          onClick={deleteAsset}
          wrapperClassName="flex items-center justify-center h-7 w-7 rounded-full cursor-pointer transition-colors duration-150 hover:bg-red-50" />
      );
    }

    return <Button onClick={deleteAsset} prefix="trash" type="TERTIARY" />;
  };

  return (
    <div className={cx('comment-asset', { 'comment-asset-v2': isV2Design })}>
      <div className={cx('asset-preview', { 'asset-preview-v2': isV2Design })}>
        <AssetPreview
          asset={asset}
          width="50px"
          height="50px"
          hideFileTypeIcon
          rounded />

      </div>
      <div
        className={cx('comment-asset__title', {
          'comment-asset__title-v2': isV2Design
        })}>

        <Text ellipsisOverflow noMargin label>
          {title}
        </Text>
        {fileExtension && <Text noMargin label>{`.${fileExtension}`}</Text>}
      </div>
      <div
        className={cx('comment-asset__download-asset-menu', {
          'comment-asset__download-asset-menu-v2': isV2Design
        })}>

        <DownloadAssetMenu asset={asset} id="comment">
          {isV2Design ?
          <Icon
            size={16}
            icon={Download}
            color="regent"
            hoverColor="darkDenim"
            wrapperClassName="flex items-center justify-center h-7 w-7 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" /> :

          <Button prefix="download" type="TERTIARY" />}

        </DownloadAssetMenu>
      </div>
      {renderDeleteAssetButton()}
    </div>);

};

export default CommentAsset;